<div class="card vision-card"
     *adaptLoading="!team">
    <div class="card-body">
        @if (isIntegratedVision) {
            <div class="d-flex flex-column align-items-start">
                <span>Define the integrated vision for team
                    <adapt-link-team [team]="team"></adapt-link-team>
                </span>
            </div>
            <button adaptButton="workflowNext"
                    (click)="defineIntegratedVisionForTeam(team!)">Integrate vision</button>
        } @else {
            <div class="d-flex flex-column align-items-start">
                <span>You are required to define your vision for team
                    <adapt-link-team [team]="team"></adapt-link-team>
                </span>
            </div>
            <button adaptButton="workflowNext"
                    (click)="defineVisionForTeamForPerson(team!)">Define vision</button>
        }
    </div>
</div>
